// ===========  media Add Class
const ctmSliderGrid = document.querySelector(".ctm-slider__grid");
if (window.matchMedia("(max-width: 700px)").matches) {
  ctmSliderGrid?.classList.remove("ctm-slider__grid");
  ctmSliderGrid?.classList.add("slider__grid");
} else {
  ctmSliderGrid?.classList.remove("slider__grid");
  ctmSliderGrid?.classList.add("ctm-slider__grid");
}

$(".custom-slick-slider").slick({
  infinite: true,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 3,
  slidesToScroll: 3,
  draggable: true,
  touchMove: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        centerMode: true,
        centerPadding: "40px",
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

// ============== Shop the look Slider For Mobile ==============

$(".shop_slider").slick({
  infinite: true,
  speed: 300,
  autoplaySpeed: 2000,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: true,
  touchMove: true,
  prevArrow:
    '<button type="button" data-role="none" class="slick-prev slideshow-nav__btn"><svg xmlns="http://www.w3.org/2000/svg" width="80" height="64" viewBox="0 0 80 64" fill="none"><rect class="ctm-btn-fill" x="80" y="64" width="80" height="64" rx="32" transform="rotate(-180 80 64)" fill="#fff" fill-opacity=".5"/><path d="m38 26 1.4 1.45L35.85 31H48v2H35.85l3.55 3.55L38 38l-6-6z" fill="#fff"/></svg></button>',
  nextArrow:
    '<button type="button" data-role="none" class="slick-next slideshow-nav__btn"><svg xmlns="http://www.w3.org/2000/svg" width="80" height="64" viewBox="0 0 80 64" fill="none"><rect class="ctm-btn-fill" width="80" height="64" rx="32" fill="#fff" fill-opacity=".5"/><path d="m42 38-1.4-1.45L44.15 33H32v-2h12.15l-3.55-3.55L42 26l6 6z" fill="#fff"/></svg></button>',
});

// triger button

var slickbtn = document.querySelectorAll(".testimonial__button");

slickbtn.forEach((element) => {
  element.addEventListener("click", function () {
    element
      .closest(".testimonial-list")
      .querySelector("#custom_right_arrow")
      .click();
  });
});

var slidebtn = document.querySelectorAll(".testimonial-list .slideshow__slide");
var testimonialbtn = document.querySelectorAll(
  ".testimonial-list .testimonial__step-btn"
);

// Function to check and add/remove 'active' class
function checkAndToggleActiveClass() {
  slidebtn.forEach(function (slide, index) {
    if (slide.classList.contains("is-active")) {
      testimonialbtn[index]?.classList.add("is-active");
    } else {
      testimonialbtn[index]?.classList.remove("is-active");
    }
  });
}

// Initial check
checkAndToggleActiveClass();

// Function to periodically check for changes
function checkForChanges() {
  setInterval(function () {
    checkAndToggleActiveClass();
  }, 1000); // Adjust the interval as needed
}

// Start checking for changes
checkForChanges();

// ============== hover funtion on header===========

document.addEventListener("DOMContentLoaded", function () {
  const logoAreaRight = document.querySelector(".logo-area__right");
  const headerGroup = document.querySelector(".section-header");

  logoAreaRight.addEventListener("mouseover", function () {
    headerGroup.classList.add("section-header--nav-hover");
  });

  logoAreaRight.addEventListener("mouseout", function () {
    headerGroup.classList.remove("section-header--nav-hover");
  });

  // ====== Shoo the look product Slider ================
  document
    .querySelectorAll(".ctm-our-picks .slideshow__slide.is-active")
    .forEach((activePrd) => {
      // console.log(activePrd.dataset.prdId);
      activePrd
        .closest(".ctm-our-picks")
        .querySelectorAll(".meta_slide--images .meta_slide--img")
        .forEach((metaImgs) => {
          if (activePrd.dataset.prdId === metaImgs.dataset.prdId) {
            // console.log(metaImgs.dataset);
            metaImgs.style.display = "block";
          } else {
            metaImgs.style.display = "none";
          }
        });
    });
  document
    .querySelectorAll(".ctm-our-picks .slideshow-nav__btn")
    .forEach((sliderBtns) => {
      sliderBtns.addEventListener("click", function () {
        setTimeout(() => {
          // console.log(this.closest('slide-show.inline-block').querySelector('.slideshow__slide.is-active').dataset.prdId);
          this.closest("slide-show.inline-block")
            .querySelector(".slideshow__slide.is-active")
            .closest(".ctm-our-picks")
            .querySelectorAll(".meta_slide--images .meta_slide--img")
            .forEach((metaImgs) => {
              if (
                this.closest("slide-show.inline-block").querySelector(
                  ".slideshow__slide.is-active"
                ).dataset.prdId === metaImgs.dataset.prdId
              ) {
                // console.log(metaImgs.dataset);
                metaImgs.style.display = "block";
              } else {
                metaImgs.style.display = "none";
              }
            });
        }, 10);
      });
    });

  // =============== FOR MOBILE =================
  document
    .querySelectorAll(".ctm-our-picks .slider__grid.product-grid--carousel")
    ?.forEach((sliderBtns) => {
      sliderBtns.addEventListener("touchend", function () {
        setTimeout(() => {
          // console.log(this.closest('slide-show.inline-block').querySelector('.slideshow__slide.is-active').dataset.prdId);
          let activeSlickDataId = this.querySelector(
            ".slick-active product-block.product-block"
          ).dataset.prdId;
          // console.log(this.closest('.ctm-our-picks'));
          this.closest(".ctm-our-picks")
            .querySelectorAll(
              ".meta_slide--images.mobile-only .meta_slide--img"
            )
            .forEach((metaImgs) => {
              // console.log(metaImgs);
              // console.log('active-slick', activeSlickDataId);
              // console.log('meta-image', metaImgs.dataset.prdId);
              if (activeSlickDataId === metaImgs.dataset.prdId) {
                // console.log(metaImgs.dataset);
                metaImgs.style.display = "block";
              } else {
                metaImgs.style.display = "none";
              }
            });
        }, 10);
      });
    });

  // ===============   PRODUCT PAGE METAFEILD BASE VARIENT IMAGES  ====================

  if (document.querySelector("body[length-product-ponytails]")) {
    // console.log('check');
    //  for varient meta images
    let varSelected = document.querySelector(".ctm_variant_id");
    let varImgId = document.querySelectorAll(
      ".product-media-collage .product-media-collage__item"
    );

    varSelected?.addEventListener("change", variantMetaImgChange);

    function variantMetaImgChange() {
      let selectedValue = document.querySelector(
        '.var_sel_id[name="id"]'
      ).value;

      if (document.querySelector(".showSlider"))
        document
          .querySelectorAll(".showSlider")
          .forEach((div) => div.classList.remove("showSlider"));

      const sliderDiv = document.querySelectorAll(
        `[varIdDesk="${selectedValue}"]`
      );
      sliderDiv[0]
        ? sliderDiv.forEach((div) => div.classList.add("showSlider"))
        : document
            .querySelectorAll(".defaultSlider")
            .forEach((div) => div.classList.add("showSlider"));
    }

    variantMetaImgChange();

    if (window.matchMedia("(max-width: 767px)")) {
      function prdSliderFn() {
        $(".ctm_slide .slik_main").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          adaptiveHeight: true,
          infinite: false,
          asNavFor: ".ctm_slide .slick_thumb_nail",
        });
        $(".ctm_slide .slick_thumb_nail").slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          asNavFor: ".ctm_slide .slik_main",
          dots: false,
          centerMode: false,
          focusOnSelect: true,
          infinite: false,
          swipeToSlide: true,
          adaptiveHeight: true,
        });
      }
      prdSliderFn();

      document.querySelectorAll(".swatch__input")?.forEach((input) => {
        input.addEventListener("change", function () {
          setTimeout(() => {
            let selectedValue = document.querySelector(
              '.var_sel_id[name="id"]'
            ).value;

            if (document.querySelector(`[varidmob='${selectedValue}']`)) {
            }
            let selDiv = document.querySelector(
              `[varidmob='${selectedValue}']`
            );
            if (selDiv) {
              let varImages = selDiv.getAttribute("var_img_gallery");
              if (varImages) {
                let varImagesArr = varImages.split(",");

                if (varImagesArr[0]) {
                  let slikMain = document.createElement("div");
                  slikMain.classList.add("slik_main");

                  let slikThumb = document.createElement("div");
                  slikThumb.classList.add("slick_thumb_nail");

                  for (let i = 0; i < varImagesArr.length; i++) {
                    slikMain.innerHTML += `<div class="meta_prd_img"><a href="${varImagesArr[i]}" data-fancybox="galleryMob"><img src="${varImagesArr[i]}" alt="" /> </a></div>`;
                    const modifiedUrl = varImagesArr[i].includes("?")
                      ? varImagesArr[i] + "&width=150"
                      : varImagesArr[i] + "?width=150";
                    slikThumb.innerHTML += `<div class="meta_prd_img"><img src="${modifiedUrl}" alt="" /> </div>`;
                  }

                  document.querySelector(".slik_main_main").innerHTML =
                    slikMain.outerHTML;
                  document.querySelector(".slick_thumb_nail_main").innerHTML =
                    slikThumb.outerHTML;
                }
              }
            } else {
              document.querySelector(".ctm_slide").innerHTML =
                document.querySelector(".ctm_slide_prd").innerHTML;
            }

            setTimeout(() => prdSliderFn(), 0);
          }, 0);
        });
      });
    }

    Fancybox.bind("[data-fancybox]", {
      // Transition effect when changing gallery items
      Carousel: {
        transition: "slide",
        Navigation: false,
      },
      // Disable image zoom animation on opening and closing
      Images: {
        zoom: false,
      },
      // Custom CSS transition on opening
      showClass: "f-fadeIn",
    });

    document.querySelectorAll("[opname]")?.forEach((op) => {
      const opname = op.getAttribute("opname");
      if (opname && opname !== "color" && opname !== "colour") {
        op.addEventListener("change", function () {
          setTimeout(() => {
            const colorAvailable = document.querySelector(
              '[opname="color"]:not(.is-unavailable)'
            );
            const colourAvailable = document.querySelector(
              '[opname="colour"]:not(.is-unavailable)'
            );
            if (
              document.querySelector(
                '[opname="color"].is-unavailable:checked'
              ) &&
              colorAvailable
            ) {
              colorAvailable.click();
            }
            if (
              document.querySelector(
                '[opname="colour"].is-unavailable:checked'
              ) &&
              colourAvailable
            ) {
              colourAvailable.click();
            }
          }, 0);
        });
      }
    });

    //  ========== STOP THE CLICK TO GO TO THE PRODUCT IMAGES FOR LENGTH ===============
    document
      .querySelectorAll(
        '.option-selector[data-option-name="Length & Style"] input'
      )
      .forEach(function (input) {
        input.addEventListener("click", function () {
          window.lengthStyleClicked = true;
        });
      });

    document
      .querySelectorAll(
        '[data-option-name="Color"] .ctm_swatch_input_warpper input'
      )
      .forEach(function (input) {
        input.addEventListener("click", function () {
          if (!window.lengthStyleClicked) {
            var slideHeight =
              document.querySelector("page-header").offsetHeight;
            window.scrollTo({
              top: slideHeight,
              behavior: "smooth",
            });
          }
          window.lengthStyleClicked = false;
        });
      });
  }
});

//  ============= PRODUCT PAGE SLIDER FOR LENGTH  & STYLE =================

$(document).ready(function () {
  if (window.matchMedia("(max-width:767px)").matches) {
    $(".ctm_swatch_slider").slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
    });
  }
});

//  ============= collection list section mobile slider =================

function initializeMobileSlider() {
  // Check if window width is 768px or less
  if ($(window).width() <= 767) {
    $(".collection-list-section-slider")
      .not(".slick-initialized")
      .slick({
        infinite: false,
        speed: 300,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 1, // For mobile, show only 1 slide
        slidesToScroll: 1,
        arrows: false, // Hide arrows
        centerMode: true,
        centerPadding: "30px",
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              autoplay: true,
            },
          },
        ],
      });
  } else {
    // If the window width is more than 768px, unslick the slider if it's initialized
    if ($(".collection-list-section-slider").hasClass("slick-initialized")) {
      $(".collection-list-section-slider").slick("unslick");
    }
  }
}

// Initialize slider on page load and window resize
$(document).ready(function () {
  initializeMobileSlider();
});

$(window).resize(function () {
  initializeMobileSlider();
});

//  ============= video section slider slider start =================
// Check if window width is 768px or less
$(".video-section-slider").slick({
  infinite: true,
  autoplay: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "30px",
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "30px",
      },
    },
  ],
});

function initializeSlider() {
  // Only initialize slick if it's not already initialized
  if (!$(".testimonials-main-slider").hasClass("slick-initialized")) {
    $(".testimonials-main-slider").slick({
      dots: false,
      infinite: false,
      autoplay: false,
      arrows: false,
      slidesToShow: 3, // Adjust as needed
      slidesToScroll: 3,
      margin: "20px",
      centerMode: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            centerPadding: "20px",
            centerMode: true,
          },
        },
      ],
    });
  }
}

// Reinitialize slider on button click
$(document).on("click", ".customer-videos--two-button button", function () {
  $(".customer-videos--two-button button").removeClass("active");
  $(this).addClass("active");
  var dataIndex = $(this).data("index");

  if (dataIndex == "1") {
    $(".customer-videos-section-slider").show();
    $(".written-section").hide();
    $(".video-section-slider").slick("refresh"); // Refresh slider
  } else if (dataIndex == "2") {
    $(".customer-videos-section-slider").hide();
    $(".written-section").show();
    initializeSlider();
    $(".testimonials-main-slider").slick("refresh"); 
    stopAllVideos();
  }
});

function stopAllVideos() {
    $(".video-section-slider video").each(function () {
        this.pause(); 
        this.currentTime = 0;
    });
}

// Detect when tab is inactive/active
document.addEventListener("visibilitychange", function() {
    if (document.hidden) {
        stopAllVideos(); 
    }
});
//  ============= video section slider slider end =================


//  ============= featured-product-v2 js start =================
    var variantID_1 = $('.featured-product-v2 input[name="id"]').val();
    function handleVariantImage(element) {
      var variantImage = $(element).data("variant-image");
      var variantID_2;
      var variantPrice = $(element).data("variant-price");
      var variantDataIndex = $(element).closest("variant-picker").data("variant-picker-index");
      
      $(".featured-product-v2 .media-content .featured-media").attr("src",variantImage);
      if(variantDataIndex == '1'){
        $(".normal-product-section .normal-product-one .normal-max-price .normal-price_max").html(variantPrice);
        $(".normal-product-section .normal-product-one .normal-product-one-img img").attr("src",variantImage);
        variantID_1 = $(element).data("variant-id");
        setTimeout(function () {
          $('input[name="id"]').val(variantID_1);
        }, 500);
      }else if(variantDataIndex == "2"){
        variantID_2 = $(element).data("variant-id");
        $(".normal-product-section .normal-product-two .normal-max-price .normal-price_max").html(variantPrice);
        $(".normal-product-section .normal-product-two .normal-product-one-img img").attr("src",variantImage);
        $('input[name="items[0][id]"]').val(variantID_2);
        setTimeout(function () {
            $('input[name="id"]').val(variantID_1);
        }, 500);
      }
    }

    $(document).on("change", '.featured-product-v2 variant-picker input', function() {
      handleVariantImage($(this));
    });

    const $featuredSection = $('.section-featured-product');

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    // Add class when the section is in view
                    $featuredSection.addClass('your-class-name');
                } else {
                    // Remove class when the section is out of view
                    $featuredSection.removeClass('your-class-name');
                }
            });
        });

        // Observe the section
        observer.observe($featuredSection[0]);
    }
//  ============= featured-product-v2 js end =================


//  ============= collapsible-tabs-v2 js start =================

$(".collapsible-tabs-v2 .collapsible-tabs__block .disclosure").first().attr("open", true);
$(document).on("click", ".collapsible-tabs-v2 .collapsible-tabs__block", function() {
    $(".collapsible-tabs-v2 .disclosure").removeAttr("open");
    const $clickedDisclosure = $(this).find(".disclosure").first();
    $clickedDisclosure.attr("open", true);
});

//  ============= collapsible-tabs-v2 js end =================